import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { ApiResponse } from '../models/api-response.models';
import { unwrapApiResponse } from '../utils/api-response';
import { ApiService } from './api.service';

export interface SupportTicket {
  id: string;
  customerUserId: string;
  category: string;
  subject: string;
  message: string;
  status: string;
  adminResponse?: string;
  createdAt: string;
  updatedAt: string;
}

@Injectable({ providedIn: 'root' })
export class SupportTicketsService {
  private readonly api = inject(ApiService);
  list(): Observable<SupportTicket[]> {
    return this.api
      .get<ApiResponse<{ tickets: SupportTicket[] }> | { tickets: SupportTicket[] }>(
        API_ENDPOINTS.supportTickets.admin,
        undefined,
        'marketplace',
      )
      .pipe(map((response) => unwrapApiResponse(response).tickets ?? []));
  }
  update(id: string, status: string, adminResponse: string): Observable<SupportTicket> {
    return this.api
      .put<
        ApiResponse<{ ticket: SupportTicket }> | { ticket: SupportTicket },
        { status: string; adminResponse: string }
      >(API_ENDPOINTS.supportTickets.byId(id), { status, adminResponse }, 'marketplace')
      .pipe(map((response) => unwrapApiResponse(response).ticket));
  }
}
